import { render, staticRenderFns } from "./PluginConfirmDialog.vue?vue&type=template&id=7e4b3f6e&scoped=true"
import script from "./PluginConfirmDialog.vue?vue&type=script&lang=js"
export * from "./PluginConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./PluginConfirmDialog.vue?vue&type=style&index=0&id=7e4b3f6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b3f6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4b3f6e')) {
      api.createRecord('7e4b3f6e', component.options)
    } else {
      api.reload('7e4b3f6e', component.options)
    }
    module.hot.accept("./PluginConfirmDialog.vue?vue&type=template&id=7e4b3f6e&scoped=true", function () {
      api.rerender('7e4b3f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plugin/PluginConfirmDialog.vue"
export default component.exports